import * as React from "react"

function BWLogo(props) {
  return (
    <svg
      viewBox="0 0 287 183"
      xmlns="http://www.w3.org/2000/svg"
      fillRule="evenodd"
      clipRule="evenodd"
      strokeMiterlimit={10}
      {...props}
    >
      <g fillRule="nonzero">
        <path
          d="M160.53 15.364v65.043c-6.197 4.588-11.911 8.56-17.128 12.087a331.19 331.19 0 01-30.092 18.62H58.913v21.657a96.854 96.854 0 01-22.74 2.926c-.732 0-1.463 0-2.253-.036a34.309 34.309 0 01-10.829-1.815V15.364h33.656v62.922h68.518V15.364h35.265zM160.53 126.574v52.276h-35.77v-31.256a411.73 411.73 0 0035.77-21.02zM58.847 168.277v10.975H23.062v-14.494c6.98 2.546 15.101 3.878 24.525 4.039h.11c3.753-.007 7.47-.19 11.15-.52zM282.414 143.007v35.85H175.72V116.55c11.472-7.857 23.142-16.63 35.294-26.544v53h71.401zM211.013 15.364V36.89c-12.906 12.738-24.67 23.106-35.294 31.724V15.364h35.294z"
          stroke="#000"
          strokeWidth={0.73164}
        />
        <path
          d="M16.11 135.22a.12.12 0 00-.09-.13h-.08c-22.52 19.22-20.57 55.09 2 73.44 13.15 10.71 30.75 13.89 47.28 14.17 56.78-.14 107.5-28.64 157.33-61.26 44.23-28.61 85.64-64.13 125.9-102.44a.1.1 0 01.14 0l19.79 18.8a.1.1 0 00.14 0 .07.07 0 000-.06L379.5.12V.11a.11.11 0 00-.1-.11l-75.69 19.92a.1.1 0 000 .14l13.73 11.84a.1.1 0 010 .14C272 80.68 235 109.71 200.55 133c-42.36 29.27-75.43 43.47-105.47 52.75-15.83 4.89-32.36 8.17-49 7.68-13-.39-27.84-4-33-17.5-5.03-12.93-1.08-28.2 3.03-40.71z"
          fill="url(#prefix___Linear1)"
          transform="scale(.73164)"
        />
      </g>
      <defs>
        <linearGradient
          id="prefix___Linear1"
          x1={0}
          y1={0}
          x2={1}
          y2={0}
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(0 111.36) scale(379.5)"
        >
          <stop offset={0} />
          <stop offset={0.5} stopColor="#242424" />
          <stop offset={1} stopColor="#575757" />
        </linearGradient>
      </defs>
    </svg>
  )
}

export default BWLogo
